import React from "react"

const teeth = [
  18, 17, 16, 15, 14, 13, 12, 11,
  21, 22, 23, 24, 25, 26, 27, 28,
  48, 47, 46, 45, 44, 43, 42, 41,
  31, 32, 33, 34, 35, 36, 37, 38
]

export default function OdontogramSelector({ selected, onSelect }) {
  return (
    <div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(8, 42px)", gap: 6, marginBottom: 8 }}>
        {teeth.slice(0, 16).map((t) => (
          <button
            key={t}
            type="button"
            onClick={() => onSelect(t)}
            style={{
              width: 42,
              height: 42,
              borderRadius: 10,
              border: selected === t ? "2px solid #1d4ed8" : "1px solid #cbd5e1",
              background: selected === t ? "#dbeafe" : "#ffffff",
              color: "#0f172a",
              fontWeight: 700,
              cursor: "pointer"
            }}
          >
            {t}
          </button>
        ))}
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(8, 42px)", gap: 6 }}>
        {teeth.slice(16).map((t) => (
          <button
            key={t}
            type="button"
            onClick={() => onSelect(t)}
            style={{
              width: 42,
              height: 42,
              borderRadius: 10,
              border: selected === t ? "2px solid #1d4ed8" : "1px solid #cbd5e1",
              background: selected === t ? "#dbeafe" : "#ffffff",
              color: "#0f172a",
              fontWeight: 700,
              cursor: "pointer"
            }}
          >
            {t}
          </button>
        ))}
      </div>
    </div>
  )
}